import { FC } from 'react';

import { Badge } from '@purpur/library';

import { formatDate } from '@telialt/utils/src/helpers';

import { CategoriesList, PublishDate, StyledArticleCategoryAndDate } from '../ContentBlogArticlePage.styles';

type Props = {
    categories: { id: string; name: string }[];
    effectiveDate: string;
    $target: 'desktop' | 'mobile';
};

export const ArticleCategoryAndDate: FC<Props> = ({ categories, effectiveDate, $target }) => {
    return (
        <StyledArticleCategoryAndDate $target={$target}>
            <CategoriesList>
                {categories.map((category) => (
                    <li key={category.id}>
                        <Badge showIcon={false} variant="information">
                            {category.name}
                        </Badge>
                    </li>
                ))}
            </CategoriesList>
            <PublishDate>{formatDate(effectiveDate)}</PublishDate>
        </StyledArticleCategoryAndDate>
    );
};
